import React from 'react';
import { StarIcon } from 'lucide-react';
import { Button } from './Button';
const INC_5000_LOGO_URL = 'https://cdn.magicpatterns.com/uploads/sXTDsich9PaBHm5nXyo3m7/Inc.-5000-Color-Medallion-Logo.png';
const G2_LOGO_URL = 'https://cdn.magicpatterns.com/uploads/uVB5XhjS12ej5LbmT6xbsF/G2_Crowd_logo.svg';
export function FinalCta() {
  return <section className="w-full border-b-2 border-brand-blue bg-black text-white" data-id="element-69" data-mp="15c2fjcfz4tth">
      <div className="mx-auto max-w-7xl px-6 py-20 lg:px-10 lg:py-28" data-id="element-70" data-mp="1jbtw9kxvkob6">
        <div className="mx-auto flex max-w-2xl flex-col items-center text-center" data-id="element-71" data-mp="1eetsjgohzxn8">
          <h2 className="font-display text-5xl uppercase leading-[0.9] sm:text-6xl lg:text-7xl" data-id="element-72" data-mp="1t2olmy6f440u">
            Ready to see your numbers move?
          </h2>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-white/60 sm:text-lg" data-id="element-73" data-mp="1o4n2yecwm6pw">
            Free 15-minute call. We look at your funnel, your offer, and where the next dollar comes from.
          </p>
          <div className="mt-8" data-id="element-74" data-mp="1x2gocu94rfya">
            <Button variant="primary" data-id="element-75" data-mp="n64bhobvbslx">Book a Call</Button>
          </div>
        </div>

        <div className="mx-auto mt-20 grid max-w-6xl gap-5 text-left sm:grid-cols-2 lg:grid-cols-4 lg:gap-6" data-id="element-76" data-mp="s4p8zfzqjy6o">
          <Recognition year="2024" data-id="element-77" data-mp="x390dvx3m26f" />
          <Recognition year="2025" data-id="element-78" data-mp="x2z4xstab2tc" />
          <G2Recognition data-id="element-79" data-mp="x64x5gx7mkta" />
          <GoogleReview data-id="element-80" data-mp="123el0s4yaof0" />
        </div>
      </div>
    </section>;
}
interface RecognitionProps {
  year: string;
}
function Recognition({
  year
}: RecognitionProps) {
  return <article className="flex min-h-[280px] flex-col border border-white/15 p-6 sm:p-7" data-id="element-81" data-mp="1b3jq2vmo9aq0">
      <span className="font-mono-eyebrow text-[10px] font-semibold uppercase tracking-[0.16em] text-brand-blue" data-id="element-82" data-mp="1b172a1u8g651">Recognition</span>
      <img src={INC_5000_LOGO_URL} alt="Inc. 5000 America's Fastest-Growing Private Companies" className="mt-5 h-20 w-20 object-contain object-left" data-id="element-83" data-mp="1ktw92jeu8vu1" />
      <div className="mt-4 font-mono-eyebrow text-xs font-semibold uppercase tracking-[0.16em] text-white/70" data-id="element-84" data-mp="1tu18o7dsipxn">{year}</div>
      <p className="mt-auto pt-4 text-sm leading-relaxed text-white/55" data-id="element-85" data-mp="3qtvxuemhj6gr">Named to the Inc. 5000 list of America’s fastest-growing private companies.</p>
    </article>;
}
function G2Recognition() {
  return <article className="flex min-h-[280px] flex-col border border-white/15 p-6 sm:p-7" data-id="element-86" data-mp="3imtwdm2wxca">
      <span className="font-mono-eyebrow text-[10px] font-semibold uppercase tracking-[0.16em] text-brand-blue" data-id="element-87" data-mp="3uw0od4hmzmz6">Recognition</span>
      <img src={G2_LOGO_URL} alt="G2 Crowd" className="mt-5 h-20 w-auto max-w-[120px] object-contain object-left" data-id="element-88" data-mp="de7ovrsqcxcj" />
      <div className="mt-4 font-mono-eyebrow text-xs font-semibold uppercase tracking-[0.16em] text-white/70" data-id="element-89" data-mp="8gfvetcft368">4.6 out of 5 rating</div>
      <div className="mt-2 flex gap-0.5 text-brand-blue" aria-label="4.6 out of 5 rating" data-id="element-90" data-mp="if57g5hnjtek">
        <Stars data-id="element-91" data-mp="2o7tzmtf0uafn" />
      </div>
      <p className="mt-auto pt-4 text-sm leading-relaxed text-white/55" data-id="element-92" data-mp="2o728pvwdd0vp">Rated by verified G2 users for the workflow, support, and clarity that keep teams moving.</p>
    </article>;
}
function GoogleReview() {
  return <article className="flex min-h-[280px] flex-col border border-white/15 p-6 sm:p-7" data-id="element-93" data-mp="2a2trpavtsfwk">
      <span className="font-mono-eyebrow text-[10px] font-semibold uppercase tracking-[0.16em] text-brand-blue" data-id="element-94" data-mp="2e2lray38rbps">Google reviews</span>
      <div className="mt-5 flex items-center gap-3" data-id="element-95" data-mp="20ae8694vrj9k">
        <img src="https://cdn.magicpatterns.com/uploads/kPT2LvQDxYJE1S7Rj98ssw/google-logo-g-suite-google-guava-google-plus.jpg" alt="Google" className="h-10 w-10 rounded-full object-cover" data-id="element-96" data-mp="25asarbnpq107" />
        <div data-id="element-97" data-mp="1vep6o09avsam">
          <div className="font-display text-4xl leading-none text-white" data-id="element-98" data-mp="1vbb3wqwq5h2n">5.0</div>
          <div className="mt-1 flex gap-0.5 text-[#fbbc05]" aria-label="Five out of five stars" data-id="element-99" data-mp="1hf7gbggcw6z5">
            <Stars data-id="element-100" data-mp="1md94gfsn2whh" />
          </div>
        </div>
      </div>
      <blockquote className="mt-5 text-sm leading-relaxed text-white/70" data-id="element-101" data-mp="3br4674z5h4s3">
        “My experience with these guys has been awesome. They have helped me grow my small business a lot!”
      </blockquote>
      <cite className="mt-auto pt-4 font-mono-eyebrow text-[10px] not-italic font-semibold uppercase tracking-[0.14em] text-white/45" data-id="element-102" data-mp="1gor3bpg7l9sx">Ian Anderson · DZRT Pest Control</cite>
    </article>;
}
function Stars() {
  return <>
      {[0, 1, 2, 3, 4].map(star => <StarIcon key={star} className="h-3.5 w-3.5 fill-current" aria-hidden="true" data-id="element-103" data-mp="12oq1a6o7jwbv" />)}
    </>;
}